import { HeadingMedium, LockIcon } from '@arnold/common';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import PublicLayout from '../../components/Common/PublicLayout';
import storage from '../../lib/storage';
import { RoundLogo } from '../Login/Common';
import LoginAside from '../Login/LoginAside';
import LoginWithMagicLinkSuccess from './LoginWithMagicLinkSuccess';

const LoginWithMagicLinkScreen = ({ match, history }: RouteComponentProps<any>) => {
  const [t] = useTranslation('loginForm');
  const lang = match.params.lang;
  const detectedLang = lang || storage.getDetectedLanguage()?.substring(0, 2);
  const emailSent = new URLSearchParams(history.location.search).get('email') ?? '';

  return (
    <PublicLayout basePath={'loginWithMagicLink'} history={history} lang={detectedLang} aside={<LoginAside />}>
      <>
        <RoundLogo>
          <LockIcon />
        </RoundLogo>
        <HeadingMedium className="text-center">{t('linkWasSent')}</HeadingMedium>
        <LoginWithMagicLinkSuccess email={emailSent} />
      </>
    </PublicLayout>
  );
};

export default LoginWithMagicLinkScreen;
